<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-meraki-switch-profiles-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                                   (detailSaved)="modal.close($event)"
                                   (detailCancelled)="modal.dismiss()">
    </app-meraki-switch-profiles-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-meraki-switch-profiles-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                                  [disabledButtons]="disabledButtons" [disabledColumns]="disabledColumns"
                                  [filters]="filters">
    </app-meraki-switch-profiles-list>
  </ng-template>
</div>